import React from 'react';
import { CheckIcon } from '@heroicons/react/solid'

function Steps2({selectedClinic, selectedDentist, setSelectedDentist, setSelectedClinic, setPickedDentist, currentStep, setCurrentStep, questionAnswers}) {

  const questAnswers = null;
  const steps = [
    { id: '1', name: 'Questionnaire', href: '#', status: currentStep>"1" && "complete" },
    { id: '2', name: 'Choose Clinic', href: '#', status: selectedClinic && "complete" },
    { id: '3', name: 'Choose Dentist', href: '#', status: selectedDentist && "complete" },
    { id: '4', name: 'Schedule appointment', href: '#', status: currentStep === "5" && "complete" },
  ]

 

  const selectStep = (step) => {
    if(currentStep !== "5"){
      setCurrentStep(step.id);
      step.id <= "2" && setSelectedClinic(null); setSelectedDentist(null); setPickedDentist(null);
      step.id === "3" && setSelectedDentist(null); setPickedDentist(null);
    }
    
  }

  
  return (
    <nav aria-label="Progress">
      <ol role="list" className="border border-gray-300 rounded-md flex w-full">
        {steps.map((step, stepIdx) => (
          <li key={step.id} className="relative flex-1 flex">
            {step.status === 'complete' ? (
              <a className="group flex items-center w-full" onClick={()=>{selectStep(step)}}>
                <span className="px-2 md:px-6 py-4 flex items-center text-lg font-medium">
                  <span className={`flex-shrink-0 w-10 h-10 flex items-center justify-center bg-primary-light rounded-full ${currentStep !== "5" && "group-hover:bg-primary"}`}>
                    <CheckIcon className="w-6 h-6 text-white" aria-hidden="true" />
                  </span>
                  <span className={`hidden md:block ml-4 text-sm sm:text-base lg:text-lg font-medium text-gray-300 ${currentStep !== "5" && "group-hover:text-gray-900"}`}>{step.name}</span>
                </span>
              </a>
            ) : step.id === currentStep ? (
              <a href={step.href} className="px-2 md:px-6 py-4 flex items-center text-lg font-medium" aria-current="step">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-primary-light rounded-full">
                  <span className="text-primary-light">{step.id}</span>
                </span>
                <span className="ml-1 md:ml-4 text-sm sm:text-base lg:text-lg font-medium text-primary-light">{step.name}</span>
              </a>
            ) : currentStep < step.id && (
              <a href={step.href} className="group flex items-center">
                <span className="px-2 md:px-6 py-4 flex items-center text-lg font-medium">
                  <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full">
                    <span className="text-gray-500">{step.id}</span>
                  </span>
                  <span className="hidden md:block ml-1 md:ml-4 text-sm sm:text-base lg:text-lg font-medium text-gray-500">{step.name}</span>
                </span>
              </a>
            )}

            {stepIdx !== steps.length - 1 ? (
              <>
                {/* Arrow separator for lg screens and up */}
                <div className="absolute top-0 right-0 h-full w-5" aria-hidden="true">
                  <svg
                    className="h-full w-full text-gray-300"
                    viewBox="0 0 22 80"
                    fill="none"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      vectorEffect="non-scaling-stroke"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Steps2;
